import React from 'react';
import MainRouter from './MainRouter';

import 'normalize.css';
import '../styling/style.scss';


export default function App() {
  return (
    <React.Fragment>
      <MainRouter />
    </React.Fragment>
  )
}